
export const PRYPCO_COLUMNS = [
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
    sticky: "left",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
    sticky: "left",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
    sticky: "left",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
    sticky: "left",
  },

  {
    Header: "Total Amount",
    Footer: "Total Amount",
    accessor: "totalAmount",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const COLUMNS = [
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
    sticky: "left",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
    sticky: "left",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
    sticky: "left",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
    sticky: "left",
  },

  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];
